"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateFaceAmount = void 0;
const factor_calculator_1 = require("../factor-calculator");
const down_payment_calculator_1 = require("./down-payment-calculator");
function calculateFaceAmount(options, rate, factor) {
    const downPaymentFace = down_payment_calculator_1.calculateDownPaymentFaceAmount(options.downPaymentAmount, rate.downPaymentFactor);
    const amount = options.amount - downPaymentFace;
    return factor_calculator_1.multiplyByFactor(amount, factor);
}
exports.calculateFaceAmount = calculateFaceAmount;
//# sourceMappingURL=face-amount-calculator.js.map